import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { FilterKey } from "@studyportals/search-filters";
import { SortingOptions } from "@/sorting/SortingOptions";

export class DisciplineCountry extends SeoMetaDataHandler {

	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const onlyDisciplineAndCountrySelected = await this.selectionOnlyFor([FilterKey.DISCIPLINES, FilterKey.COUNTRY], filterSelectionState);
		const singleDisciplineSelected = await this.singleSelectionFor(FilterKey.DISCIPLINES, filterSelectionState);
		const singleCountrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);

		return metaRankingSortSelected && onlyDisciplineAndCountrySelected && singleDisciplineSelected && singleCountrySelected;
	}

	protected async selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const discipline = this.getFilterOptionNameBy(FilterKey.DISCIPLINES, filterSelectionState);
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);

		const seoInfo = {
			title: `Best Universities for ${discipline} in ${country} | SP Meta Ranking`,

			description:
				`Discover leading universities in ${country} offering ${discipline} programmes. ` +
				`Search, filter and assess to find the best university for your ${discipline} study.`,
		};

		return Promise.resolve(seoInfo);
	}
}
